export const socialMediaLinks = {
  why: {
    twitter: "https://x.com/whyanelephant",
    tg: "https://t.me/whyenelephant",
    website: "https://www.madphant.com/",
  },
  bnx: {
    website: "https://www.binaryx.pro/",
    twitter: "https://x.com/binary_x",
    tg: "https://t.me/binaryxGlobal",
  },
  babydoge: {
    website: "https://babydoge.com/",
    twitter: "https://x.com/babydogecoin",
    tg: "https://t.me/babydogearmy",
  },
  twitter: "https://x.com/fomome_me",
  tg: "https://t.me/fomome_official",
};

export const subgraphUrl =
  "https://api.studio.thegraph.com/query/91634/skyler-fomome-bsctestnet/version/latest";

export const maxUint256 = BigInt(
  "115792089237316195423570985008687907853269984665640564039457584007913129639935"
);
